import { useState } from "react";
import { useAccountContext } from "./useAccountContext";
import { useAuthContext } from "./useAuthContext";
import { useSettingsContext } from "./useSettingsContext";
import axios from 'axios';

export const useEvents = () => {
    const { username, user, clientApi, dispatch: authDispatch } = useAuthContext();
    const { account } = useAccountContext();
    const { isWinAuth } = useSettingsContext();

    const axiosInstance = axios.create({
        baseURL: `${clientApi}`,
        headers: {
            'accepts': 'application/json',
            'Content-Type': 'application/json',
        },
    });

    axiosInstance.interceptors.request.use(request => {
        // console.log('Set Bearer Token')
        const accessToken = user.token;
        if (accessToken) {
            request.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return request;
    }, error => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(
        response => response, // Directly return successful responses.
        async error => {
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
                try {
                    if (!isWinAuth) {
                        // Make a request to your auth server to refresh the token.
                        const response = await axiosInstance.post(`${clientApi}api/auth/refresh`, user);
                        // Store the new access and refresh tokens.
                        authDispatch({ type: 'Refresh', payload: response.data, clientApi: clientApi, username: username });

                        // Update the authorization header with the new access token.
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    }
                    else {
                        const newToken = await acquireSilentToken();
                        let tmpUser = user;
                        tmpUser.token = newToken;
                        authDispatch({ type: 'REFRESH', payload: tmpUser, clientApi: clientApi, username: username });
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                    }
                    return axios(originalRequest); // Retry the original request with the new access token.
                } catch (refreshError) {
                    // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                    console.error('Token refresh failed:', refreshError);
                    authDispatch({ type: 'LOGOUT' });
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error); // For all other errors, return the error as is.
        }
    );

    //#region MyRegistrations
    const loadUsersRegEvents = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/event/GetUsersRegistrations`, {
                params: { username: account.username }
            });
            return response.data;
        } catch (error) {
            console.log(error)
            return [];
        }
    }

    const loadAllEvents = async () => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/event/GetAllEventsWithDate`, {
                params: { username: account.username }
            });
            return response.data;
        } catch (error) {
            //console.log(error)
            return [];
        }
    }

    //#region Participants
    const registerToEvent = async (eventUI) => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/event/RegisterToEvent`, {
                params: { username: account.username, eventUI: eventUI }
            });
            return response.data;
        } catch (error) {
            //console.log(error)
            return [];
        }
    }

    const cancelRegistrationToEvent = async (eventUI) => {
        try {
            const response = await axiosInstance.get(`${clientApi}api/event/CancelRegistrationToEvent`, {
                params: { username: account.username, eventUI: eventUI }
            });
            return response.data;
        } catch (error) {
            //console.log(error)
            return [];
        }
    }

    return { loadUsersRegEvents, loadAllEvents, registerToEvent, cancelRegistrationToEvent }

}